import { IStore } from 'store/configureStore';

export const selectCostCenterState = (state: IStore) => {
    return state.modules.settings.clientsSettings.clients.costCenters;
};
